<template>
	<vcl-app>
		<router-view />
	</vcl-app>
</template>

<script>
export default {
	name: `App`
};
</script>
